/* eslint-disable max-len */
import { PureComponent } from 'react';
/** @namespace Bodypwa/Component/ResetIcon/Component */

export class ResetIconComponent extends PureComponent {
    render() {
        return (
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM13.091 6L10 9.09978L6.90897 6L6.02259 6.88889L9.11362 9.98867L6 13.1111L6.88638 14L10 10.8776L13.1136 14L14 13.1111L10.8864 9.98867L13.9774 6.88889L13.091 6Z" fill="#070707" />
            </svg>

        );
    }
}

export default ResetIconComponent;
